import { render, staticRenderFns } from "./ShiftClotsForm.vue?vue&type=template&id=1b60c086&"
import script from "./ShiftClotsForm.vue?vue&type=script&lang=ts&"
export * from "./ShiftClotsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports